
export const modalBackgroundStyles = {
  display: 'block'
};

export const modalDialogStyles = {
  margin: '30px auto',
  maxWidth: '500px',
  zIndex: '9999'
};

export const modalContentStyles = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5rem',
  boxShadow: '0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22)',
  borderRadius: '3px',
  marginTop: '7em',
  border:'none'
};

export const modalBackdropStyles = {
  opacity: '.26'
};

//Modal header div
export const modalHeaderStyles = {
  borderBottom: 'none',
  paddingTop: '24px',
  paddingRight: '24px',
  paddingBottom: '0px',
  paddingLeft: '24px'
};

//H4 in modal header
export const modalHeadingStyles = {
  marginBottom: '0',
  fontWeight: '300',
  lineHeight: '1.1',
  fontSize: '21px'
};

export const modalBodyStyles = {
  paddingTop: '24px',
  paddingRight: '24px',
  paddingBottom: '16px',
  paddingLeft: '24px',
  borderBottom: 'none',
  fontSize: '14px',
  fontWeight: '400'
};

export const modalFooterStyles = {
  borderTop: 'none',
  paddingTop: '0'
};
